"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomerSelection = CustomerSelection;
var _zod = require("@hookform/resolvers/zod");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _reactHookForm = require("react-hook-form");
var _FormattedMessage = require("../../../components/FormattedMessage");
var _styled = require("../../../styled");
var _types = require("../../../types");
var _CustomerSelectionFormContent = require("./CustomerSelectionFormContent");
var _CustomerSelectionValidationSchema = require("./CustomerSelectionValidationSchema");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function CustomerSelection() {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const form = (0, _reactHookForm.useForm)({
    mode: 'onChange',
    defaultValues: {
      customerType: _types.ECustomerTypeSelection.Myself,
      existingCustomerId: null,
      customerFirstName: '',
      customerSurname: ''
    },
    // There is some random type issue with current zod and @hookform/resolvers versions
    resolver: (0, _zod.zodResolver)(_CustomerSelectionValidationSchema.customerSelectionValidationSchema)
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.StyledCustomerSelection, {
    ...getTestIdProps(`customer-selection`),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      variant: "body1",
      sx: {
        fontWeight: 'bold'
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: "for"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHookForm.FormProvider, {
      ...form,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.FormGrid, {
        ...getTestIdProps('customer-selection-form'),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomerSelectionFormContent.CustomerSelectionFormContent, {})
      })
    })]
  });
}
